<template>
  <section class="logo-section">
    <div class="container">
      <div class="logos">
        <div
          v-for="(logo, key) in logos"
          :key="key"
          class="logo"
        >
          <NuxtImg
            :src="`/images/role-page/logos/${logo.name}.svg`"
            :alt="logo.name"
            loading="lazy"
          />
          <a
            v-if="logo.video"
            @click="openVideoModal(logo.video)"
          >
            WATCH CLIENTS STORY
          </a>
        </div>
      </div>
    </div>
    <ModalWindow
      class="video-modal"
      :show="showVideoModal"
      @close="closeVideoModal()"
    >
      <div class="content-wrapper">
        <video
          ref="video"
          poster="/videos/logos/poster.png"
          controls
        >
          <source
            :src="videoSrc"
            type="video/mp4"
          />
        </video>
        <CloseCircleIcon
          class="close-icon"
          @click="closeVideoModal()"
        />
      </div>
    </ModalWindow>
  </section>
</template>

<script>
import ModalWindow from '~/components/Common/UI/ModalWindow/ModalWindow.vue';
import CloseCircleIcon from '~/components/Common/Svg/CloseCircleIcon.vue';
export default {
  components: {
    ModalWindow,
    CloseCircleIcon,
  },
  data() {
    return {
      logos: [
        {
          name: 'fibbl',
          video: '/videos/logos/fibbl.mp4',
        },
        {
          name: 'king',
          video: null,
        },
        {
          name: 'ef',
          video: '/videos/logos/ef.mp4',
        },
        {
          name: 'pearson',
          video: null,
        },
        {
          name: 'winamp',
          video: null,
        },
      ],
      showVideoModal: false,
      videoSrc: '',
    };
  },
  methods: {
    trackEvent() {
      this.$analytics.track('CTA Clicked', {
        page_name: 'Roles Pages',
        cta_name: 'Watch video',
        section: 'Company logos',
      });
    },
    playVideo() {
      this.$refs.video.play();
    },
    resetVideo() {
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },
    setVideo(newVideoSource) {
      this.videoSrc = newVideoSource;
      this.$refs.video.load();
    },
    openVideoModal(newVideoSource) {
      if (newVideoSource !== this.videoSrc) {
        this.setVideo(newVideoSource);
      }
      this.showVideoModal = true;
      this.trackEvent();
      this.$nextTick(() => {
        this.playVideo();
      });
    },
    closeVideoModal() {
      this.showVideoModal = false;
      this.resetVideo();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './LogoSection.scss';
</style>
